import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from "react";
import { usePostOnboardingDataMutation } from "../../../store/api/onboardingApi";
import { useAppSelector } from "../../../hooks/store-hooks";
import { useNavigate } from "react-router-dom";
import { ONBOARDING_PAGE_ID } from "../../../constants";
import { ONBOARDING_BUSINESS_DETAILS } from "../../../helpers/validation-schema";
import { ONBOARDING_ROUTE_MAPPING } from "../../../constants/routes";
import ProfessionalDetailsComp from "../../../components/onboarding/professional-details";
import AuthLayout from "../../../components/layouts/auth";


const BusinessDetails = () => {

    const [postOnboardingData] = usePostOnboardingDataMutation()

    const { data: onboardingData }: any = useAppSelector(state => state.onboarding || {})

    const screenName = ONBOARDING_PAGE_ID.USER_PROFESSIONAL_DETAILS;

    const navigate = useNavigate()

    type BusinessFormData = {
        industry?: string,
        company_name?: string,
        company_location?: string,
        designation?: string,
    };

    const methods = useForm<BusinessFormData>({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        resolver: yupResolver<BusinessFormData>(ONBOARDING_BUSINESS_DETAILS),
        defaultValues: {
            industry: "",
            company_name: "",
            company_location: "",
            designation: "",
        }
    })

    const { handleSubmit, formState: { errors }, control, setValue } = methods

    useEffect(() => {
        if (onboardingData?.page_id === screenName) {
            const pageData = onboardingData?.page_data || [];
            pageData.forEach((itm: any) => {
                setValue(itm?.field_name, itm?.value)
            })
        }

    }, [onboardingData])

    const onSubmit = async(data: BusinessFormData) => {
        const response = await postOnboardingData({ page_id: ONBOARDING_PAGE_ID.USER_PROFESSIONAL_DETAILS, ...data })
        if (response?.data?.success) {
            const nextPageId: any = response.data?.data?.nextPage || ""
            navigate(ONBOARDING_ROUTE_MAPPING?.[nextPageId])
        }
    };

    return (
        <FormProvider {...methods}>
            <AuthLayout screenName = {screenName}>
                <form className="flex w-full h-full" onSubmit={handleSubmit(onSubmit)}>
                    <ProfessionalDetailsComp />
                </form>
            </AuthLayout>
        </FormProvider>

    )
}

export default (BusinessDetails)